export default "__VITE_ASSET__Cmqh8ksC__"